import React, { useState, useCallback } from 'react';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import { useTimeout } from '../../../utils/hooks/useTimeout';
var timeToWaitForInteraction = 3000;
var maxAnimationDuration = 5000;
export var GlinteractionContext = React.createContext({
    onGotInteraction: function () { return null; },
    onGlintDone: function () { return null; },
    shouldGlint: false,
});
GlinteractionContext.displayName = 'GlinteractionContext';
export var GlinteractionProvider = function (_a) {
    var children = _a.children;
    var hasFlag = useFlag('animated_actions');
    var _b = useState(false), shouldGlint = _b[0], setShouldGlint = _b[1];
    var resetInteraction = useCallback(function () { return setShouldGlint(Math.round(Math.random()) ? 'comment' : 'fave'); }, []);
    var resetGlint = useCallback(function () { return setShouldGlint(false); }, []);
    var resetInteractionTimeout = useTimeout(resetInteraction, timeToWaitForInteraction, hasFlag);
    // generous safety timeout in case end callback is not called
    // (eg. animationend event is not supported)
    var resetGlintTimeout = useTimeout(resetGlint, maxAnimationDuration, hasFlag && !!shouldGlint);
    var onGlintDone = useCallback(function () {
        setShouldGlint(false);
        resetGlintTimeout();
    }, [resetGlintTimeout]);
    if (!hasFlag) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(GlinteractionContext.Provider, { value: {
            onGotInteraction: resetInteractionTimeout,
            onGlintDone: onGlintDone,
            shouldGlint: shouldGlint,
        } }, children));
};
GlinteractionProvider.displayName = 'GlinteractionProvider';
//# sourceMappingURL=Glinteraction.js.map